import { render, staticRenderFns } from "./OrderListCancelNew.vue?vue&type=template&id=0ffd80f5"
import script from "./OrderListCancelNew.vue?vue&type=script&lang=js"
export * from "./OrderListCancelNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports